import type { FC } from "react";
import { Box, Group, Text } from "@mantine/core";
import { Dropzone, type FileWithPath } from "@mantine/dropzone";
import { notifications } from "@mantine/notifications";
import { IconCloudUpload } from "@tabler/icons-react";

// Upload policy limit of the back (content-length-range of the presigned S3 upload, V1 and V2)
const MAX_FILE_SIZE = 100_000_000;
// Same stroke as the icons of the order page
const ICON_STROKE = 1.75;

const DROPZONE_BORDER_WIDTH = "1.5px";
// Dashed zone, brand tint on hover and while files are dragged over it
const DROPZONE_STYLES = {
  root: {
    borderWidth: DROPZONE_BORDER_WIDTH,
    borderColor: "var(--mantine-color-ink-2)",
    "&:hover, &[data-accept]": {
      borderColor: "var(--mantine-color-brand-4)",
      backgroundColor: "var(--mantine-color-brand-0)",
    },
    "&[data-reject]": {
      borderColor: "var(--mantine-color-danger-4)",
      backgroundColor: "var(--mantine-color-danger-0)",
    },
  },
};

const notifyFileTooLarge = () =>
  notifications.show({
    color: "danger",
    title: "Fichier trop volumineux",
    message: "100 Mo maximum par fichier",
  });

type FileDropzoneProps = {
  description: string;
  isLoading: boolean;
  onDrop: (files: FileWithPath[]) => void;
};

// Where files are dropped or picked to be added to an order (review page, order page)
export const FileDropzone: FC<FileDropzoneProps> = ({
  description,
  isLoading,
  onDrop,
}) => (
  <Dropzone
    onDrop={onDrop}
    onReject={notifyFileTooLarge}
    maxSize={MAX_FILE_SIZE}
    loading={isLoading}
    radius="lg"
    px="s4"
    py="s3"
    styles={DROPZONE_STYLES}
  >
    <Group gap="s3" wrap="nowrap">
      <IconCloudUpload
        size={20}
        stroke={ICON_STROKE}
        color="var(--mantine-color-brand-6)"
      />
      <Box>
        <Text variant="strong">Ajouter des fichiers</Text>
        <Text variant="caption">{description}</Text>
      </Box>
    </Group>
  </Dropzone>
);
